import styled from 'styled-components'
import {Button} from '@mui/material'

const ButtonForInput = styled(Button)`
  height: 37.63px;
  margin-left: 22px;
`

export default ButtonForInput
